<div class="modal-header">
	<h4 class="modal-title fw-bold">
		<span jhiTranslate="merge-germplasm.title"></span>
	</h4>
	<button type="button" class="btn-close" data-bs-dismiss="modal" aria-hidden="true"
			(click)="dismiss()">
	</button>
</div>
<div class="modal-body">
	<span jhiTranslate="merge-germplasm.select-germplasm-caption"></span>
	<br/><br/>
	<i class="fa fa-exclamation-circle text-danger"></i>&nbsp;<span jhiTranslate="merge-germplasm.non-selected-germplasm-caption"></span>
	<div class="table-responsive" *ngIf="germplasmList">
		<table class="table table-striped table-bordered table-curved" *ngIf="germplasmList.length">
			<thead>
			<tr>
				<th><span jhiTranslate="merge-germplasm.column.target"></span></th>
                <th><span jhiTranslate="merge-germplasm.column.exclude"></span></th>
				<th><span jhiTranslate="search-germplasm.column.gid"></span></th>
				<th><span jhiTranslate="merge-germplasm.column.location"></span></th>
				<th *jhiHasAnyAuthority="VIEW_NAMES_PERMISSION" style="max-width: 200px; word-wrap: break-word; white-space: normal;"><span jhiTranslate="merge-germplasm.column.names"></span></th>
				<th><span jhiTranslate="search-germplasm.column.lotCount"></span></th>
				<th><span jhiTranslate="merge-germplasm.column.hasProgeny"></span></th>
				<th *ngIf="showCrossColumn()"><span jhiTranslate="merge-germplasm.column.cross"></span></th>
				<th><span jhiTranslate="search-germplasm.column.groupId"></span></th>
			</tr>
			</thead>
			<tbody>
			<tr *ngFor="let germplasm of germplasmList; trackById: trackId">
				<td>
					<input type="radio" name="gid-option-group" [checked]="isSelected(germplasm)" (click)="toggleSelect(germplasm)">
				</td>
                <td>
                    <input type="checkbox" name="excluded-gids-checkbox" [checked]="isExcluded(germplasm)" (click)="toggleExclude(germplasm)" [disabled]="isSelected(germplasm)" >
                </td>
				<td><a class="link" (click)="openGermplasmDetailsInTab(germplasm.gid)">{{germplasm.gid}}</a></td>
				<td>{{germplasm.locationName}}</td>
				<td *jhiHasAnyAuthority="VIEW_NAMES_PERMISSION" style="max-width: 200px; word-wrap: break-word; white-space: normal;">{{germplasm.names}}</td>
				<td><a *ngIf="germplasm.lotCount" (click)="$event.stopPropagation(); inventoryDetailsPopupService.open(germplasm.gid)">{{germplasm.lotCount}}</a>
					<span *ngIf="germplasm.lotCount === 0">-</span></td>
				<td><a *ngIf="germplasm.hasProgeny" (click)="$event.stopPropagation()" [routerLink]="['/', { outlets: { popup: 'germplasm-progeny-dialog' } }]" [queryParams]="{gid: germplasm.gid}" queryParamsHandling="merge">YES</a><span *ngIf="!germplasm.hasProgeny">NO</span></td>
				<td *ngIf="showCrossColumn()"><truncate-span [textInput]="germplasm.pedigreeString" [maxLength]="MAX_NAME_DISPLAY_SIZE"></truncate-span></td>
				<td><a *ngIf="germplasm.groupId" (click)="openGermplasmDetailsInTab(germplasm.groupId)">{{germplasm.groupId}}</a><span *ngIf="!germplasm.groupId">-</span></td>
			</tr>
			</tbody>
		</table>
	</div>
	<div class="row">
		<div class="col">
			<span jhiTranslate="merge-germplasm.variables.and.names"></span>
			<hr/>
		</div>
	</div>
	<div class="mb-3 row">
		<div class="col">
			<div class="form-check form-check-inline">
				<input type="checkbox" class="form-check-input" name="transferPassportData" id="transferPassportData"
					   [(ngModel)]="isTransferPassportData">
				<label class="form-check-label" for="transferPassportData" jhiTranslate="merge-germplasm.transfer-passport-data">
				</label>
			</div>
			<br/>
			<div class="form-check form-check-inline">
				<input type="checkbox" class="form-check-input" name="transferAttributesData" id="transferAttributesData"
					   [(ngModel)]="isTransferAttributesData">
				<label class="form-check-label" for="transferAttributesData" jhiTranslate="merge-germplasm.transfer-attributes-data">
				</label>
			</div>
			<br/>
			<div class="form-check form-check-inline">
				<input type="checkbox" class="form-check-input" name="transferNameTypesData" id="transferNameTypesData"
					   [(ngModel)]="isTransferNameTypesData">
				<label class="form-check-label" for="transferNameTypesData" jhiTranslate="merge-germplasm.transfer-names-types-data">
				</label>
			</div>
			<br/>
			<div class="form-check form-check-inline">
				<input type="checkbox" class="form-check-input" name="transferFiles" id="transferFiles"
					   [(ngModel)]="isTransferFiles">
				<label class="form-check-label" for="transferFiles" jhiTranslate="merge-germplasm.transfer-files">
				</label>
			</div>
		</div>
	</div>
</div>
<div class="modal-footer">
	<button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="dismiss()" [disabled]="isLoading">
		<span class="fa fa-ban"></span>&nbsp;
		<span jhiTranslate="cancel"></span>
	</button>
	<button (click)="confirm()" class="btn btn-primary" [disabled]="isLoading || !selectedGid">
		<span *ngIf="isLoading" class="throbber throbber-btn"></span>
		<span class="fa fa-save"></span>&nbsp;
		<span jhiTranslate="merge-germplasm.confirm"></span>
	</button>
</div>
